import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './ProtectedRoute.css';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, login } = useAuth();

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      login();
    }
  }, [loading, isAuthenticated, login]);

  if (loading) {
    return (
      <div className="auth-loading">
        <div className="auth-spinner"></div>
        <p>Authentifizierung wird überprüft...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="auth-redirect">
        <div className="auth-spinner"></div>
        <p>Weiterleitung zum Login...</p>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
